import styled from "styled-components";

import { constants, spacing, theme } from "../../layout";

export const Form = styled.form`
  border: 1px solid ${theme.border};
  background-color: ${theme.form.background};
  border-radius: ${constants.radius.view}px;
  display: flex;
  flex-direction: column;
  min-width: 280px;
  max-width: 375px;
  padding: 0px ${constants.divPadding}px;
`;

export const Heading = styled.div`
  margin-left: ${spacing.xxs}px;
  margin-top: ${spacing.m}px;
  margin-bottom: ${spacing.m}px;
`;
